import RequireAuthentication from '@/router/guards/RequireAuthentication'
import { lazy } from 'react'
import DiscountPharmacies from './pages/DiscountPharmacies'

const MyBenefits = lazy(() => import('./pages/MyBenefits'))
const HealthInsuranceSummary = lazy(
  () => import('./pages/HealthInsuranceSummary'),
)
const CommonQuestion = lazy(() => import('./pages/CommonQuestion'))
const PartnerLaboratories = lazy(() => import('./pages/PartnerLaboratories'))

const MyBenefitsRoutes = [
  <RequireAuthentication
    path="/meus-beneficios"
    key="/beneficios"
    exact
    component={MyBenefits}
  />,
  <RequireAuthentication
    path="/meus-beneficios/seguro-de-vida"
    key="/meus-beneficios/seguro-de-vida"
    exact
    component={HealthInsuranceSummary}
  />,
  <RequireAuthentication
    path="/meus-beneficios/seguro-de-vida/duvidas-frequentes"
    key="/meus-beneficios/seguro-de-vida/duvidas-frequentes"
    exact
    component={CommonQuestion}
  />,
  <RequireAuthentication
    path="/meus-beneficios/laboratorios-parceiros"
    key="/meus-beneficios/laboratorios-parceiros"
    exact
    component={PartnerLaboratories}
  />,
  <RequireAuthentication
    path="/meus-beneficios/farmacias-desconto"
    key="/meus-beneficios/farmacias-desconto"
    exact
    component={DiscountPharmacies}
  />,
]

export default MyBenefitsRoutes
